import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import React, { useEffect } from "react";
import { MessageResponse } from "../../../model/MessageResponse";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";
import { title } from "process";
import {
  Box,
  Button,
  Grid,
  Group,
  LoadingOverlay,
  Textarea,
  TextInput,
} from "@mantine/core";
import {
  createUserCommentReply,
  modifyUserComment,
} from "../../../api/ApiUserComment";
import ButtonClose from "../../../common/ButtonClose/ButtonClose";
type Props = {
  data?: any;
  onClose: any;
  isEditMode: boolean;
  ungvienid?: number;
  name?: string;
};
const FormComent = ({ data, onClose, isEditMode }: Props) => {
  const entity = {
    id: 0,
    commentId: data.id,
    isUserAdmin: null,
    userId: null,
    userEmail: "userEmail@gmail.com",
    userName: "userName",
    userAvatar: null,
    userNote: null,
    rate: null,
    title: null,
    content: null,
    files: null,
    approved: 1,
    postTime: null,
    ipAddress: null,
    orderNumber: null,
    isFeatured: null,
    peopleIdVote: null,
    peopleLikeCount: null,
    peopleDislikeCount: null,
    creationDate: null,
    createdBy: null,
    lastUpdateDate: null,
    lastUpdateBy: null,
  };
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const form = useForm<any>({
    mode: "controlled",
    validateInputOnChange: true,
    initialValues: isEditMode ? data : entity,
  });
  const handleSubmit = async (dataSubmit: any) => {
    open();
    await (isEditMode
      ? modifyUserComment(dataSubmit)
      : createUserCommentReply(dataSubmit));
    onClose((prev: any) => !prev);
    modals.closeAll();
    close();
  };
  useEffect(() => {
    if (isEditMode) {
      form.setValues({
        title: data.title || null,
        content: data.content || null,
      });
    }
  }, [isEditMode]);

  return (
    <div>
      <Box
        component="form"
        mx="auto"
        onSubmit={form.onSubmit(handleSubmit)}
        style={{ position: "relative", width: "500px" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Grid mt="md">
          <Grid.Col span={12}>
            <TextInput
              label="Sản phẩm"
              defaultValue={data.itemTitle}
              readOnly
              disabled
            />
          </Grid.Col>
          {isEditMode && (
            <Grid.Col span={12}>
              <TextInput
                label="Tiêu đề"
                placeholder="Nhập Tiêu đề"
                key={form.key("title")}
                {...form.getInputProps("title")}
              />
            </Grid.Col>
          )}
          <Grid.Col span={12}>
            <Textarea
              styles={{
                input: {
                  height: "200px",
                },
              }}
              label="Nội dung"
              placeholder="Nhập Nội dung"
              key={form.key("content")}
              {...form.getInputProps("content")}
            />
          </Grid.Col>
        </Grid>

        <Group
          justify="center"
          mt="xs"
          p="5px 0"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button type="submit" loading={visible}>
            Lưu
          </Button>
          <ButtonClose />
        </Group>
      </Box>
    </div>
  );
};

export default FormComent;
